<script setup lang="ts">
import { useCurrentUserRole } from "@/api/current-user";
import { useUser } from "@/api/user-query";
import UserSettings from "@/components/users/UserSettings.vue";
import NotFound from "@/pages/__404__.vue";
import { mdiChevronDoubleLeft } from "@mdi/js";
import { Role } from "@soft-db/monitoring-api-client";
import { Button, Icon } from "@soft-db/ui";

const { t } = useI18n();

const route = useRoute();
const router = useRouter();

const id = computed(() => (route.params.userid || "") as string);
function goBack() {
	router.push({
		name: "spaces-id",
		params: { id: route.params.id },
	});
}

const { data: user, error } = useUser(id);
const { hasRole } = useCurrentUserRole();

const rolesAllowed = computed<Role[]>(() => {
	const roles: Role[] = ["viewer", "editor", "admin"];

	return roles.filter((r) => hasRole(r));
});
</script>

<template>
	<div class="pb-4">
		<Button variant="outline" @click="goBack">
			<Icon :d="mdiChevronDoubleLeft" />
			<span>{{ t("space.back") }}</span>
		</Button>
	</div>
	<NotFound v-if="error" />
	<UserSettings
		v-else-if="user"
		:id="id"
		:user="user"
		:rolesAllowed="rolesAllowed"
		@back="goBack"
	/>
</template>
